import * as React from "react";
import { useCallback, useState } from "react";
import { useField } from "formik";
import PlusButton from "report/report-creation/common/PlusButton";
import AddWidgetForm from "report/report-creation/content/AddWidgetForm";
import AddWidgetDrawer from "./AddWidgetDrawer";
const AddWidget = ({ disabled }) => {
  const [{ value: widgets }, , { setValue }] = useField("widgets");
  const [show, setShow] = useState(false);
  const onClick = useCallback(() => setShow(true), []);
  const onClose = useCallback(() => setShow(false), []);
  const onSubmit = useCallback(
    async (updatedWidgets) => {
      setValue(updatedWidgets);
      setShow(false);
    },
    [setValue]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PlusButton, { title: "Add widgets", onClick, disabled }), show && /* @__PURE__ */ React.createElement(AddWidgetDrawer, { onClose }, /* @__PURE__ */ React.createElement(AddWidgetForm, { onClose, widgets, onSubmit })));
};
export default AddWidget;
